var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",staticStyle:{"box-shadow":"0 2px 5px 0 rgb(0 21 41 / 8%)"}},[_c('Logo'),_c('Menu'),_c('Tools')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }